import React from "react";

import AboutUser from "./about-user";
import AboutCompany from "./about-company";

const UserInfo = (props) => {
  const {
    firstName,
    lastName,
    phoneNumber,
    email,
    tempEmail,
    registrationDate,
    businessAddress,
    taxCode,
    promoCode,
    dealerCode,
    ambassadorCode,
    branches,
    remaining_branches,
    setIsBranchCountMode,
    setIsChangeEmailMode,
    setIsPromoCodeMode,
    setIsDealerCodeMode,
    setIsAmbassadorCodeMode,
    billingExpirationDate,
    setIsChangeBillingExpirationDateMode,
    contractNumber,
    setIsContractNumberMode,
  } = props;

  return (
    <div className="user_info_wrapper p-4 mb-spacing-6">
      <AboutUser
        firstName={firstName}
        lastName={lastName}
        phoneNumber={phoneNumber}
        email={email}
        tempEmail={tempEmail}
        registrationDate={registrationDate}
        setIsChangeEmailMode={setIsChangeEmailMode}
        billingExpirationDate={billingExpirationDate}
        setIsChangeBillingExpirationDateMode={setIsChangeBillingExpirationDateMode}
      />
      <AboutCompany
        businessAddress={businessAddress}
        taxCode={taxCode}
        promoCode={promoCode}
        dealerCode={dealerCode}
        ambassadorCode={ambassadorCode}
        branches={branches}
        remaining_branches={remaining_branches}
        setIsBranchCountMode={setIsBranchCountMode}
        setIsPromoCodeMode={setIsPromoCodeMode}
        setIsDealerCodeMode={setIsDealerCodeMode}
        setIsAmbassadorCodeMode={setIsAmbassadorCodeMode}
        contractNumber={contractNumber}
        setIsContractNumberMode={setIsContractNumberMode}
      />
    </div>
  );
};

export default UserInfo;
